import { takeLatest } from 'redux-saga/effects';
import { GlobalActions, SnapshotManager } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export const snapshotManager = new SnapshotManager(App.TKV_V2);

export function* watchStreckeSnapshot() {
  yield takeLatest(
    GlobalActions.CREATE_STRECKEN_SNAPSHOT,
    safeSaga(snapshotManager.createSnapshot, App.TKV_V2),
  );
  yield takeLatest(
    GlobalActions.RESTORE_STRECKEN_SNAPSHOT,
    safeSaga(snapshotManager.restoreSnapshot, App.TKV_V2),
  );
}
